/** Azərbaycan — default dil */
const az = {
  lang: {
    caption: "Dil",
    aria: "Saytın dilini dəyişdirin — cari: ",
  },
  a11y: {
    skipToMain: "Əsas məzmuna keç",
  },
  nav: {
    home: "Ana səhifə",
    services: "Xidmətlər",
    portfolio: "Portfolio",
    about: "Haqqımızda",
    contact: "Əlaqə",
    cta: "WhatsApp-da yazın",
  },
  hero: {
    offer: "Saytlar, çat-botlar və biznesiniz üçün sorğular",
    h1a: "Qeydiyyat və sorğular üçün sayt və ya bot — ",
    h1b: "biznesinizə uyğun",
    h2: "Müraciətləri, saytdan sorğuları və WhatsApp, Instagram, Telegram axınlarını qururuq",
    ctaReview: "Pulsuz məsləhət alın",
    ctaContact: "Telegram-da yazın",
    imgAlt: "Broxe Group — biznes üçün saytlar və çat-botlar",
  },
  solution: {
    beforeBrand: "",
    afterBrand: " nə edir: saytlar, botlar və sorğu qəbulu",
    lead:
      "Alətləri qururuq və tənzimləyirik — səhifə, bot, ssenari. Gəlir və satış təklifinizdən və müştəri ilə işinizdən asılıdır; texniki tərəfi biz əhatə edirik.",
    l1: "Sayt və bot sizin təsdiqlədiyiniz ssenari ilə işləyir: cavab, qeydiyyat, sorğu",
    l2: "Adətən 3–7 günə işə hazır həll — sonra prosesi siz idarə edirsiniz",
    l3: "Qeydiyyat və sorğular bir zəncirdə — çatlarda əl ilə yazışma azalır",
    ctaConsult: "Məsləhət alın",
    quote:
      "Gəlir vəd etmirik. İşlək botlar, lendinq və inteqrasiyalar veririk — istifadə sizin əlinizdədir.",
  },
  servicesPrev: {
    beforeH: "Biznes üçün ",
    highlight: "alətlər",
    afterH: ": sayt, bot, sorğular",
    intro:
      "Lendinq, çat-botlar, sadə sorğu sistemləri və nişə ssenariləri — tapşırığa uyğun, artıq yox.",
    s1t: "Çat-botlar",
    s1d:
      "WhatsApp, Instagram, Telegram: şablon cavab, qeydiyyat, sorğu — siz məşğul olanda.",
    s2t: "Sorğular və sistemlər",
    s2d:
      "Sayt və mesencerlərdən sorğular bir yerdə — sizin və əməkdaşınız üçün rahat.",
    s3t: "Saytlar",
    s3d:
      "Biznes üçün lendinq: tez işə düşmə, aydın mətn, sorğu forması.",
    s4t: "Nişənizə uyğun",
    s4d:
      "Klinikalar, deteylinq, salonlar, barbershoplar, auto servis — hazır ssenarilər.",
    btn: "Xidmətlərə bax",
  },
  process: {
    beforeH: "Üç addım — ",
    highlight: "tapşırıqdan işə salınmaya",
    p1t: "Tapşırığı dəqiqləşdiririk",
    p1d:
      "İndi sorğuları necə qəbul edirsiniz: telefon, çat, sayt — və əvvəlcə nə avtomatlaşdırılmalıdır.",
    p2t: "Hazırlayırıq və işə salırıq",
    p2d:
      "Sayt, bot və ya sorğu axını — adətən 3–7 günə istifadəyə yararlı versiya.",
    p3t: "Lazım olsa düzəldirik",
    p3d:
      "Rəyinizə görə mətn və ssenariləri dəyişirik — sizə və müştəriyə rahat olanda qədər.",
  },
  ctaFinal: {
    title: "Tapşırığınızı müzakirə edək",
    sub:
      "Pulsuz məsləhət və ya qısa zəng: nə qoşmaq olar və necə işləyirik — gəlir zəmanəti yoxdur.",
    req: "Məsləhət alın",
    demo: "Telegram-da yazın",
  },
  social: {
    title: "Yazın — xidmətlər haqqında cavab verəcəyik",
    or: "və ya",
    p2: ": şəhər və sahə — oxşar hallarda adətən hansı addımlar olur",
  },
  faq: {
    title: "Tez-tez verilən suallar",
    subtitle: "Saytlar, botlar və sorğular — ən çox sorulanlar",
    items: [
      {
        q: "İlk işə salınma nə qədər çəkir?",
        a: "Adətən 3–7 iş günü: sayt, bot və ya sorğu qəbulu. Sonra rəyinizə görə düzəliş edirik.",
      },
      {
        q: "Dərhal reklamı artırmalıyam?",
        a: "Məcbur deyil. Əvvəlcə artıq yazanları qəbul etmək olar: cavab, qeydiyyat, sayt forması. Reklam ayrı qərardır.",
      },
      {
        q: "Kimə uyğundur?",
        a: "Deteylinq, klinika, salon, barbershop, auto servis, yerli biznes, Instagram mağazası — internet və mesencerlərdən sorğu və qeydiyyat lazımdırsa.",
      },
      {
        q: "Yalnız WhatsApp və Telegram?",
        a: "Xeyr. WhatsApp, Instagram, Telegram — razılaşdığımız kimi. Müştəriyin sorğu və ya qeydiyyatı asan buraxması üçün qururuq.",
      },
      {
        q: "Necə başlamaq olar?",
        a: "Niş, şəhər və əsas kanal yazın (məs. WhatsApp). Sayt düymələri mesencerləri açır — məsləhət istəyə bilərsiniz.",
      },
      {
        q: "Qiymət necə hesablanır?",
        a: "Həcmdən: kanallar, sayt lazımdırmı, botun dərinliyi. Tapşırığa görə — məcburi paket yox.",
      },
    ],
  },
  aboutPage: {
    h1a: "Biz kimik və ",
    h1b: "nə edirik",
    imgAlt: "Broxe Group — biznes üçün saytlar, çat-botlar və sorğular",
  },
  aboutCard: {
    p1rest:
      "sifarişlə lendinq, WhatsApp, Instagram və Telegram çat-botları, sadə sorğu sistemləri və salon, klinika, deteylinq, auto servis və sosial mağazalar üçün hazır ssenarilər hazırlayır. Məqsəd tapşırığa uyğun işlək həll — investor slaydları deyil.",
    p2:
      "Sayt və bot alətdir: müştəri qeydiyyatdan keçə və ya sorğu buraxa bilər. Sonra bu müraciətlərlə necə işləmək sizin tərəfinizdədir.",
    li1: "Aydın alətlər — sayt, bot, sorğular — boş «brend» söhbəti yox",
    li2: "Cavab və qeydiyyatı sizin qaydalarınıza və qrafikinizə görə qururuq",
    li3: "Müddət günlərdə, rübdə yox — tez işə salırıq və rəyə görə düzəldirik",
    quote: "Marketinqinizi əvəz etmirik — işlək botlar və səhifələr veririk.",
  },
  servicesPage: {
    h1a: "Biznes üçün ",
    h1b: "nə edirik",
    p1:
      "Tapşırığa uyğun birləşmə: sayt, bot, formalıqlar, inteqrasiyalar — siz nə istəmisiniz.",
    p2:
      "Başlanğıc adətən 3–7 gün; dəqiq müddət qısa müzakirədən sonra.",
  },
  servicesDetail: {
    chatbot: {
      title: "Çat-botlar",
      bullets: [
        "WhatsApp, Instagram, Telegram — ssenari cavabları, qeydiyyat, sorğu",
        "Təkrarlanan əl mesajları az — bot addımlarla gedir",
        "Hər kanal üçün bir ssenari — saxlamaq asandır",
      ],
    },
    automation: {
      title: "Sorğular və sadə sistemlər",
      bullets: [
        "Sayt və mesencer sorğuları bir yerdə",
        "Cədvəl və ya yüngül CRM — istəyə görə",
        "Əlaqələri əl ilə köçürmə azalır",
      ],
    },
    sites: {
      title: "Saytlar və lendinq",
      bullets: [
        "Aydın əməliyyatlı lendinq: mesaj, zəng və ya sorğu",
        "Tez işə düşmə — mətni sonra dəyişmək olar",
        "Mobil ekranlar üçün düzülüş",
      ],
    },
    content: {
      title: "Nişə uyğun həllər",
      bullets: [
        "Klinikalar, deteylinq, salonlar, barbershoplar, auto servis — formatınıza şablonlar",
        "Qiymət, ünvan, xidmətlər, qeydiyyat — sizin siyahınızdan",
        "Sonra aksiya və dəyişikliklər üçün kiçik düzəlişlər",
      ],
    },
  },
  contact: {
    h1a: "Yazın — ",
    h1b: "tapşırığı müzakirə edək",
    intro:
      "WhatsApp və ya Telegram — cavab verəcəyik və nə qura biləcəyimizi deyəcəyik. Aşağıda birbaşa keçidlər var.",
    waPrefillReview:
      "Salam! Biznesim üçün sayt və sorğular üzrə pulsuz məsləhət istəyirəm (Broxe Group).",
    waPrefillConsult:
      "Salam! Məsləhət lazımdır: sayt, çat-bot və ya sorğular (Broxe Group).",
    waPrefillDemo:
      "Salam! Biznes üçün sayt və ya bot müzakirə etmək istəyirəm (Broxe Group).",
    waPrefillNav: "Salam! Broxe Group ilə əlaqə saxlamaq istəyirəm.",
    tgPrefillContact:
      "Salam! Broxe Group saytından yazıram, sorğular və sayt haqqında danışmaq istəyirəm.",
    tgPrefillDemo:
      "Salam! Biznes üçün sayt və ya bot müzakirə etmək istəyirəm (Broxe Group).",
  },
  leadForm: {
    name: "Ad",
    phone: "Telefon və ya Telegram",
    phName: "Ünvana müraciət",
    phPhone: "+994 … və ya @username",
    alert:
      "Sorğu qəbul olundu. Yazacaq və ya zəng edəcəyik — tapşırığı dəqiqləşdirəcəyik: sayt, bot və ya sorğu qəbulu.",
    submitDefault: "Sorğu buraxın",
    submitConsult: "Məsləhət alın",
  },
  serviceCard: {
    demo: "WhatsApp-da yazın",
  },
  footer: {
    tagline:
      "Biznes tapşırığına uyğun saytlar və çat-botlar. Alətlər sizin əlinizdədir.",
    ariaWa: "Broxe Group WhatsApp",
    ariaTg: "Broxe Group Telegram",
  },
  homeAria: {
    wa: "Broxe Group WhatsApp-da yazın",
    tg: "Broxe Group Telegram-da yazın",
  },
  portfolio: {
    sectionTitle: "Seçilmiş işlər",
    sectionSubtitle: "Ayrı-ayrı layihələr: interfeyslər, saytlar və demo videolar.",
    viewAll: "Bütün layihələrə bax",
    pageTitle: "Portfolio — bütün layihələr",
    pageSubtitle:
      "Şəkillər qalereya kimi, videolar isə birbaşa təkrarlanır. Fayllar saytın kökündəki portfolio qovluğundan yüklənir.",
    badgeGallery: "Şəkillər",
    badgeVideo: "Video",
    copyLink: "Linki kopyala",
    linkCopied: "Kopyalandı",
    items: {
      adminPanel: {
        title: "Admin panel",
        desc: "İdarəetmə paneli — ekran görüntüləri.",
      },
      lardiTrans: {
        title: "Lardi-Trans",
        desc: "Ləvhə və funksionallıq üçün səhifələr.",
      },
      regemsal: {
        title: "Regemsal",
        desc: "Layihə üçün əsas səhifələr.",
      },
      tutAz: {
        title: "Tut.az",
        desc: "Məhsul və əsas səhifə.",
      },
      projectManager: {
        title: "Layihə meneceri",
        desc: "Məhsul interfeysindən fraqmentlər.",
      },
      jsdelivr: {
        title: "jsDelivr statistikası",
        desc: "Şəbəkə və statistik ekranlar.",
      },
      lg2: {
        title: "Layihə (lg2)",
        desc: "Əsas səhifə variantları.",
      },
      podriadchik: {
        title: "Podratçı platforması",
        desc: "Marketpleys, şirkət və çat ekranları.",
      },
      apiBoost: {
        title: "API Boost",
        desc: "İnterfeys ekranları və ssenarilər.",
      },
      alivaria: {
        title: "Alivaria",
        desc: "Səhifələr və UI detalları.",
      },
      belInter: {
        title: "Bel Inter",
        desc: "İnterfeysdən fraqmentlər.",
      },
      bitcoinEmpire: {
        title: "Bitcoin Empire",
        desc: "Tətbiq ekranları.",
      },
      tringleSpace: {
        title: "Tringle Space",
        desc: "Əsas interfeys ekranları.",
      },
      espireo: {
        title: "Espireo",
        desc: "Layihə ekranları.",
      },
      huskyHelp: {
        title: "Husky Help",
        desc: "Səhifələr və istifadə ssenariləri.",
      },
      presentashki: {
        title: "Presentashki",
        desc: "Ekranlar və maketlər.",
      },
      video: {
        desc: "Layihə üzrə qısa video demo.",
      },
      v0074: { title: "Auth System" },
      v0076: { title: "Standoff Duel" },
      v0081: { title: "A1 CRM" },
      v0082: { title: "Korpu" },
      v0083: { title: "Outlet Store" },
      v0088: { title: "Chat System" },
      v0089: { title: "T-Movies" },
      v0091: { title: "DND-Kanban" },
      v0092: { title: "Med Yu Med" },
      v0094: { title: "Payment System" },
      v0095: { title: "Chat System" },
    },
  },
  seo: {
    siteName: "Broxe Group",
    ogImageAlt: "Broxe Group — biznes üçün saytlar və çat-botlar",
    keywords:
      "lendinq, biznes saytı, WhatsApp çat-bot, Instagram bot, Telegram bot, saytdan sorğu, onlayn qeydiyyat, deteylinq, klinika, gözəllik salonu, barbershop, auto servis, Instagram mağazası",
    home: {
      title: "Broxe Group — biznes üçün saytlar və çat-botlar",
      description:
        "Lendinq, WhatsApp, Instagram və Telegram çat-botları, sorğu qəbulu, nişə həlləri. Deteylinq, klinika, salon, yerli biznes. WhatsApp və Telegram.",
    },
    services: {
      title: "Broxe Group xidmətləri — saytlar, çat-botlar, sorğular",
      description:
        "Mesencerlər üçün çat-botlar, lendinq, sadə sorğu sistemləri, salon və mağazalar üçün ssenarilər. Tapşırığı müzakirə edib format seçirik.",
    },
    about: {
      title: "Broxe Group haqqında — kiçik və yerli biznes üçün saytlar və botlar",
      description:
        "Broxe Group: lendinq, botlar, sorğu qəbulu. Salonlar, klinikalar, deteylinq, auto servis, sosial mağazalar.",
    },
    contact: {
      title: "Broxe Group əlaqə — WhatsApp və Telegram",
      description:
        "Broxe Group ilə WhatsApp və ya Telegram-da əlaqə: sayt, bot və sorğular haqqında suallar.",
    },
    portfolio: {
      title: "Broxe Group portfolio — iş nümunələri və demo videolar",
      description:
        "İş nümunələri: interfeyslər, səhifələr, demo videolar. Bütün nümunələr bir səhifədə.",
    },
  },
};

export default az;
